import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PreloadAllModules } from '@angular/router';

// Home
import { HomeComponent } from './pages/home/home.component';

// Portfolio
import { PortfolioListComponent } from './pages/portfolio/portfolio-list/portfolio-list.component';
import { PortfolioPageComponent } from './pages/portfolio/portfolio-page/portfolio-page.component';
import { PortfolioRoutingComponent } from './pages/portfolio/portfolio-routing/portfolio-routing.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full',
  },
  {
    path: 'home',
    component: HomeComponent,
  },
  {
    path: 'portfolio',
    component: PortfolioRoutingComponent,
    data: {
      breadcrumb: 'Portfolio',
    },
    children: [
      {
        path: '',
        component: PortfolioListComponent,
        data: {
          breadcrumb: '',
        },
      },
      {
        path: ':id',
        component: PortfolioPageComponent,
        data: {
          breadcrumb: '',
        },
      },
    ],
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts